import React, { useState, useEffect } from "react";
import {Button, Col, Modal, Row, Spin, Form, notification} from "antd";
import InputField from "@components/input-field";
import { edoService } from "../../../services/edo.services";
import { consignorService } from "../../../services/consignor.services";
import SelectField from "../../select-field";

export default function ModalEdoShipperAuth({isShow, setIsShow, setIsNeedUpdate}) {
  const [loading, setLoading] = useState(false);

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [typesList, setTypesList] = useState([]);
  const [consignorsList, setConsignorsList] = useState([]);
  const [shipperCompanies, setShipperCompanies] = useState([]);
  const [fieldsErrors, setFieldsErrors] = useState({});
  const [typeName, setTypeName] = useState("-");
  const [selectedType, setSelectedType] = useState(null);
  const [selectedConsignor, setSelectedConsignor] = useState(null);
  const [selectedShipperCompany, setSelectedShipperCompany] = useState(null);
  const [priority, setPriority] = useState(1);

  const [tmpSession, setTmpSession] = useState(false);
  const [tmpKey, setTmpKey] = useState(false);
  const [confirmCode, setConfirmCode] = useState('');

  let bigButtonStyle = { width: '200px', height: '43px', background: '#1CAA53', position: 'static', borderRadius: '10px' };
  let confirmButtonStyle = { width: '200px', height: '43px', background: '#1CAA53', position: 'static', borderRadius: '10px', marginTop: 'auto' };

  useEffect(() => {
    if (!typesList.length && isShow) {
      setLoading(true);
      Promise.all([
        edoService.getTypes(),
        consignorService.getConsignorsList(),
      ])
        .then(([types, consignors]) => {
          setTypesList(types);
          setConsignorsList(consignors);
          if (types.length > 0) {
            setSelectedType(types[0].Id);
            setTypeName(types[0].Name);
          }
          setLoading(false);
        })
        .catch((error) => {
          notification.error({
            message: "Ошибка загрузки данных", description: error,
          });
          setLoading(false);
        });
    }
  }, [isShow]);

  const handleConsignorChange = (value) => {
    setSelectedConsignor(value);
    setSelectedShipperCompany(null);
    setLoading(true);
    consignorService.getShipperCompaniesList(value)
      .then((shippers) => {
        setShipperCompanies(shippers);
        setLoading(false);
      })
      .catch((error) => {
        notification.error({message: "Ошибка загрузки компаний", description: error});
        setLoading(false);
      });
  };

  const onSubmitFormEdoAuth = e => {
    e.preventDefault();
    if (!selectedShipperCompany) {
      notification.error({message: "Авторизация", description: "Не выбрана компания"});
      return;
    }
    setLoading(true);
    edoService.authShipperByLogin(selectedType, username, password, selectedShipperCompany, priority)
      .then((response) => {
          setLoading(false);
          if (response.status === "success") {
            if(response.needConfirm || false) {
              notification.success({message: "Авторизация", description: response.message});
              setTmpSession(response.addInfo.ИдентификаторСессии);
              setTmpKey(response.addInfo.Идентификатор);
            } else {
              notification.success({message: "Авторизация", description: response.message});
              setIsNeedUpdate(true);
              closeAndClearModal();
            }
          } else if (response.status === "error"){
              setFieldsErrors(response.errors);
          }
      })
      .catch((error) => {
          notification.error({message: "Авторизация", description: error});
          setLoading(false);
      });
  };

  const onSubmitConfirmAuth = e => {
    e.preventDefault();
    setLoading(true);
    edoService.authConfirm(selectedType, tmpSession, tmpKey, confirmCode)
      .then((response) => {
          setLoading(false);
          if (response.status === "success") {
              notification.success({message: "Авторизация", description: response.message});
              setIsNeedUpdate(true);
              closeAndClearModal();
          } else if (response.status === "error"){
              setFieldsErrors(response.errors);
          }
      })
      .catch((error) => {
          notification.error({message: "Авторизация", description: error});
          setLoading(false);
      });
  };

  const getFieldErrors = fieldName => {
    return typeof fieldsErrors[fieldName] !== "undefined"
      ? fieldsErrors[fieldName].reduce((fieldErrors, error) => {
          return fieldErrors + "; " + error;
        })
      : null;
  };

  const closeAndClearModal = () => {
    setTmpKey(false);
    setTmpSession(false);
    setConfirmCode('');
    setIsShow(false);
  }

  const handleTypeChange = (value) => {
    setSelectedType(value);
    const type = typesList.find(t => t.Id === value);
    if (type) {
      setTypeName(type.Name);
    }
  };

  return (
    <Modal
      title={"Авторизация в " + typeName}
      cancelText="Закрыть"
      className="modal-window"
      align={null}
      visible={isShow}
      onCancel={() => {
        setIsNeedUpdate(true);
        closeAndClearModal();
      }}
      footer={[
        <Button htmlType="submit" key="submit" disabled={tmpSession} style={bigButtonStyle} type="primary" onClick={onSubmitFormEdoAuth}>
          Войти
        </Button>
      ]}
    >
      <Spin spinning={loading} tip="Загрузка...">
        <Form>
          <Row gutter={[16, 24]}>
            <Col span={24}>
              <SelectField
                title="Тип ЭДО"
                name="type"
                selectedValue={selectedType}
                values={typesList.map(t => ({Id: t.Id, Name: t.Name}))}
                onChange={handleTypeChange}
                getErrors={getFieldErrors}
              />
            </Col>
            <Col span={24}>
              <SelectField
                title="Грузоотправитель"
                name="consignor_id"
                selectedValue={selectedConsignor}
                values={consignorsList}
                onChange={handleConsignorChange}
                getErrors={getFieldErrors}
              />
            </Col>
            <Col span={24}>
              <SelectField
                title="Компания"
                name="shipper_company_id"
                selectedValue={selectedShipperCompany}
                values={shipperCompanies}
                onChange={setSelectedShipperCompany}
                getErrors={getFieldErrors}
              />
            </Col>
            <Col span={24}>
              <InputField
                name="priority" label="Приоритет (чем больше - тем выше)" type="number"
                value={priority} setValue={setPriority}
                getFieldErrors={getFieldErrors}
              />
            </Col>
            <Col span={24}>
              <InputField
                name="username" label="Email / Телефон"
                value={username} setValue={setUsername}
                getFieldErrors={getFieldErrors}
              />
            </Col>
            <Col span={24}>
              <InputField
                name="password" label="Пароль" type="password"
                value={password} setValue={setPassword}
                getFieldErrors={getFieldErrors}
              />
            </Col>
          </Row>
          {(tmpSession && tmpKey) &&
          <Row gutter={[16, 24]} style={{ display: 'flex', alignItems: 'stretch' }}>
            <Col span={12}>
              <InputField
                name="username" label="Код подтверждения"
                value={confirmCode} setValue={setConfirmCode}
                getFieldErrors={getFieldErrors}
              />
            </Col>
            <Col span={12} style={{display: 'flex', flexDirection: 'column', justifyContent: 'flex-end'}}>
              <Button htmlType="submit" key="submit" style={confirmButtonStyle} disabled={!confirmCode} type="primary" onClick={onSubmitConfirmAuth}>
                Отправить код
              </Button>
            </Col>
          </Row>}
        </Form>
      </Spin>
    </Modal>
  );
}